export default __webpack_public_path__ + "static/media/LI.f22c5faa.svg";